export default "__VITE_ASSET__CvjQwzIp__"